import BatchOptimizationProvider from '@/application/providers/BatchOptimizationProvider'
import {validationFunctions as vf} from  '@/application/libs/validations'
import {validateFields, getFormatedError} from  '@/application/libs/validations'
import Util from  '@/application/libs/util'
import moment from 'moment'

function BatchOptimizationService(){
    
    this.fetchBatchData = () => {
        return BatchOptimizationProvider.fetchBatchData();
    };
    
    this.getBatchScenario = ({NRGERACAOCARD}) => {
        return BatchOptimizationProvider.getBatchScenario(NRGERACAOCARD);
    };
    
    this.getGenerationSummary = ({NRITGERACAOCARD}) => {
        return BatchOptimizationProvider.getGenerationSummary(NRITGERACAOCARD);
    };

    this.getPublicationSummary = ({NRLOGINTCARDAMES}) => {
        return BatchOptimizationProvider.getPublicationSummary( NRLOGINTCARDAMES );
    };
    
    this.newBatchProcedureCaller = (objectNewBatch) => BatchOptimizationProvider.newBatchProcedureCaller(objectNewBatch);
    
    this.getTypeCost = function(){
        return BatchOptimizationProvider.getTypeCost();
    };
    
    this.getGrupProd = function(){
        return BatchOptimizationProvider.getGrupProd();
    };
    
    this.getLinkedScenario = function({DTMESGERACAOCARD: DTMESCARD, IDTIPORESTRICAO, CDFILIAL, CDSERVFILI}){
        return BatchOptimizationProvider.getLinkedScenario(DTMESCARD, IDTIPORESTRICAO, CDFILIAL, CDSERVFILI);
    };

    this.getSceneryPublish = function({NRITGERACAOCARD}){
        return BatchOptimizationProvider.getSceneryPublish(NRITGERACAOCARD);
    }
    
    this.getPublicationSummary = ({NRLOGINTCARDAMES}) => {
        return BatchOptimizationProvider.getPublicationSummary( NRLOGINTCARDAMES );
    };

    this.getCabecalhoExportLog = function( NRITGERACAOCARD ){
        return BatchOptimizationProvider.getCabecalhoExportLog( NRITGERACAOCARD );
    }

    this.generateScenery = ( scenery ) => BatchOptimizationProvider.generateScenery( scenery );
    
    this.saveBatchScenarioGrid = (params, updateKey) => {
        
        return BatchOptimizationProvider.saveChangedData(
        [params], updateKey);
    };

    this.publishScenery = ( scenery ) => BatchOptimizationProvider.publishScenery( scenery );

    this.calculateAlert = ( params ) => BatchOptimizationProvider.calculateAlert( params );

    this.updateStatusItems = ( params ) => BatchOptimizationProvider.updateStatusItems( params );

    this.updateStatusItGeracaoCard = (NRITGERACAOCARD, IDSTATUSGERACAO, NRCENARIOPUBLICAR, NRLOGINTCARDAMES) => BatchOptimizationProvider.updateStatusItGeracaoCard( NRITGERACAOCARD, IDSTATUSGERACAO, NRCENARIOPUBLICAR, NRLOGINTCARDAMES);

    this.getGenerationAlert = ( NRITGERACAOCARD ) => BatchOptimizationProvider.getGenerationAlert( NRITGERACAOCARD );

    this.getLinkedService = ( NRGERACAOCARD ) => BatchOptimizationProvider.getLinkedService( NRGERACAOCARD ); 

}

export default new BatchOptimizationService();